import React from 'react';
import { useCartData } from '../../../hooks/order';
import InstalltionInfo from '../../common/InstalltionInfo';

export const is5GPlan = (internetPlan, isWhiAdded) => Boolean(isWhiAdded
  || internetPlan?.serviceName?.toLowerCase()?.includes('5g')
  || internetPlan?.servCode?.toLowerCase()?.includes('5g')
  || internetPlan?.techDetail?.toLowerCase()?.includes('5g'));

// Thin wrapper around the existing installation/activation info callout - InstalltionInfo.js
// already has the vendor-fee copy, install-window text and first-month note reused everywhere
// else in checkout, so this just supplies its props from the shared cart hook.
// No callout for 5G plans. This rule stays here, not in the shared InstalltionInfo.js, so it
// can't affect the multi-step checkout.
const InstallActivationInfo = () => {
  const { oneTimeCharge, internetPlan, isWhiAdded } = useCartData();
  if (is5GPlan(internetPlan, isWhiAdded)) {
    return null;
  }
  return <InstalltionInfo oneTimeCharge={oneTimeCharge} internetPlan={internetPlan} />;
};

export default InstallActivationInfo;
